import { Asset, AssetTypes } from '../../domain/Asset';

export const getAssetLocation = (asset: Asset, type: AssetTypes) => {
  if (!asset.childAssets) {
    return asset.url;
  }

  return asset.childAssets?.find((childAsset) => childAsset.type === type)?.url;
};
